// AWS Amplify configuration for authentication and API
export const amplifyConfig = {
    Auth: {
      Cognito: {
        region: process.env.REACT_APP_REGION || 'us-east-1',
        userPoolId: process.env.REACT_APP_USER_POOL_ID,
        userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
        mandatorySignIn: true,
      }
    },
    API: {
      REST: {
        mmfBackupApi: {
          endpoint: process.env.REACT_APP_API_URL,
          region: process.env.REACT_APP_REGION || 'us-east-1',
        }
      }
    }
  };